import { StudentIntakeForm } from '@applyboard/ab-student-intake-form';

export default StudentIntakeForm;
